import axiosInstance from "./api";

export const createConfig = async (
  type,
  key,
  value,
  expiry_type = null,
  expiry_seconds = null,
  viewScope = null,
  editScope = null,
  deleteScope = null,
) => {
  const expiry =
    expiry_type && expiry_seconds
      ? { type: expiry_type, seconds: expiry_seconds }
      : null;
  const scopes = viewScope || editScope || deleteScope ? {} : null;
  if (viewScope) scopes.view = viewScope;
  if (editScope) scopes.edit = editScope;
  if (deleteScope) scopes.delete = deleteScope;
  const request = {
    type: type,
    key: key,
    value: value,
    expiry: expiry,
    scopes: scopes,
  };
  const result = await axiosInstance.post("/api/configuration/", request);
  return result?.data?.data || null;
};

export const getConfigs = async (
  type = "",
  keys = null,
  exactMatch = true,
  start = null,
  end = null,
) => {
  let keyParams = "";
  if (keys) {
    keyParams = `&keys=${keys.join(",")}`;
  }
  let dateRange = "";
  if (start) {
    dateRange += `&start=${start}`;
  }
  if (end) {
    dateRange += `&end=${end}`;
  }
  const results = await axiosInstance.get(
    `/api/configuration/?type=${type}${keyParams}&exact_match=${exactMatch}${dateRange}`,
  );
  return results?.data?.data || [];
};

export const getConfig = async (id) => {
  const result = await axiosInstance.get(`/api/configuration/${id}`);
  return result?.data?.data || null;
};

export const getConfigByTypeKey = async (type, key) => {
  key = key.replaceAll("/", "-SLASH-");
  const result = await axiosInstance.get(`/api/configuration/${type}/${key}`);
  return result?.data?.data || null;
};

export const updateConfig = async (
  id,
  type,
  key,
  value,
  viewScope = null,
  editScope = null,
  deleteScope = null,
) => {
  const scopes = viewScope || editScope || deleteScope ? {} : null;
  if (viewScope) scopes.view = viewScope;
  if (editScope) scopes.edit = editScope;
  if (deleteScope) scopes.delete = deleteScope;
  const request = {
    type: type,
    key: key,
    value: value,
  };
  if (scopes) {
    request.scopes = scopes;
  }
  const result = await axiosInstance.put(`/api/configuration/${id}`, request);
  return result?.data?.data || null;
};

export const deleteConfig = async (id) => {
  const result = await axiosInstance.delete(`/api/configuration/${id}`);
  return result?.data?.data || null;
};
